import {FETCH_NOTIFICATION_SETTING_SUCCESS,} from "../../constants/ActionTypes";
import {message} from 'antd';
import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {history} from "../store";

export const fetchResourceSuccess = (data) => {
  return {
    type: FETCH_NOTIFICATION_SETTING_SUCCESS,
    data
  };
};

export const fetchResource = (serviceName) => {
  console.log('here we send service name for backend', serviceName)
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/notification-setting/`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export let updateResource = (payload, serviceName) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/notification-setting/${serviceName}`, payload);
      // console.log(response);
      dispatch(fetchSuccess());
      history.push('/notification-setting');
    } catch (error) {
      message.error(error.response.data.message);
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

